import React from 'react';

const LanguageIcon = ({
    width = 24,
    height = 24,
    stroke = '#000',
    strokeWidth = 1,
    ...props
}) => (
    <svg
        id={'languageIconTitle'}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        role="img"
        aria-labelledby="languageIconTitle"
        width={width}
        height={height}
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="square"
        strokeLinejoin="miter"
        color={stroke}
        {...props}
    >
        <title id="languageIconTitle">Language</title>
        <circle cx="12" cy="12" r="10" />
        <path
            strokeLinecap="round"
            d="M12,22 C14.6666667,19.5757576 16,16.2424242 16,12 C16,7.75757576 14.6666667,4.42424242 12,2 C9.33333333,4.42424242 8,7.75757576 8,12 C8,16.2424242 9.33333333,19.5757576 12,22 Z"
        />
        <path strokeLinecap="round" d="M2.5 9L21.5 9M2.5 15L21.5 15" />
    </svg>
);

export default LanguageIcon;
